export const testIsFree = (value: string) => /^€0\.00$/.test(value);
